<template>
  <div
    ref="footerRef"
    class="footer"
    :style="{ top: `calc(100% - ${footerHeight}px)` }"
  >
    <div class="tw-text-xs">
      Je bent ingelogd als {{ userName }} ({{ roleName(user.role[0]) }}) bij
      {{ schoolName }} (#{{ schoolId }}) Catwise versie: {{ version }}
    </div>

    <div v-if="isDevelopmentEnvironment && buildDate" class="tw-text-xs">
      Laatst bijgewerkt op {{ buildDate }}
      {{ buildBranch ? ` (${buildBranch})` : "" }}
    </div>
  </div>
</template>

<script setup>
import useHelpers, { isDevelopmentEnvironment } from "composables/useHelpers";
import { ref, onMounted, onBeforeUnmount } from "vue";

const UPDATE_HEIGHT_DEBOUNCE_VALUE = 150;

const version = import.meta.env?.VITE_APP_VERSION;
const buildDate = import.meta.env?.VITE_BUILD_DATE;
const buildBranch = import.meta.env?.VITE_BUILD_BRANCH;

const { userName, schoolId, schoolName, user, roleName, debounce } =
  useHelpers();

const footerRef = ref(null);
const footerHeight = ref(0);

let resizeObserver = null;

const updateHeight = debounce(() => {
  if (footerRef.value) {
    footerHeight.value = footerRef.value.offsetHeight;
  }
}, UPDATE_HEIGHT_DEBOUNCE_VALUE);

onMounted(() => {
  updateHeight();

  resizeObserver = new ResizeObserver(updateHeight);
  resizeObserver.observe(footerRef.value);
});

onBeforeUnmount(() => {
  resizeObserver?.disconnect();
});
</script>

<style lang="scss" scoped>
.footer {
  @apply tw-sticky tw-mt-10 tw-flex tw-flex-col tw-justify-center tw-gap-x-4 tw-bg-gray-50 tw-px-2 tw-py-4 tw-text-center tw-text-gray-600;
}
</style>
